import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import _ from "lodash";
import moment from "moment";

import { CommonButton } from "components/Common/ButtonCommon";
import HeaderCreateItem from "components/Common/HeaderCreateItem";
import useGetFormSchema from "custom-hook/useGetFormSchema";
import { addUser, updateUser } from "redux-toolkit/slices/Users/userSlice";
import httpService from "services/httpService";
import { checkAdmin, splitFullName } from "helpers/erp_helper";
import {
  toastrCRUDSuccess,
  toastrErrorAlert,
} from "components/Common/AlertToastr";
import { TEXT_POST, TEXT_PUT } from "helpers/name_helper";
import { language_vn } from "helpers/language_vn";

const NewAccount2 = () => {
  const [previousRoles, setPreviousRoles] = useState([]);

  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();

  const excludeFields = id ? ["password"] : [];

  useEffect(() => {
    getDetail();
  }, [id]);

  const schema = yup
    .object({
      username: yup.string().required("This field is required!"),
      password: !id && yup.string().required("This field is required!"),
      roles: yup.array().nullable(),
    })
    .required();

  const {
    handleSubmit,
    formState: { errors },
    ...rest
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(schema),
  });

  const { renderForm } = useGetFormSchema("_User", yup, rest, errors);

  const getDetail = async () => {
    if (!id) return;

    const roleResponse = await httpService.get(
      `/parse/classes/_Role?where={"users": {"__type":"Pointer", "className": "_User", "objectId": "${id}"}}`
    );
    const userResponse = await httpService.get(`/parse/classes/_User/${id}`);

    const { reset } = rest;
    const roles = roleResponse.results.map(role => ({
      __type: "Pointer",
      className: "_Role",
      objectId: role.objectId,
    }));
    setPreviousRoles(roles);
    reset({
      ...userResponse,
      roles,
      dob: moment(userResponse?.dob?.iso).format("YYYY-MM-DD"),
    });
  };

  const onSubmit = async values => {
    try {
      const { createdAt, updatedAt, roles, email, dob, ...accountValues } =
        values;

      const account = {
        ...accountValues,
      };

      if (id) {
        const clearRequests = previousRoles.map(role => ({
          method: "PUT",
          path: `/parse/classes/_Role/${role.objectId}`,
          body: {
            users: {
              __op: "RemoveRelation",
              objects: [
                { __type: "Pointer", className: "_User", objectId: id },
              ],
            },
          },
        }));
        const updateRequests = roles.map(role => ({
          method: "PUT",
          path: `/parse/classes/_Role/${role.objectId}`,
          body: {
            users: {
              __op: "AddRelation",
              objects: [
                { __type: "Pointer", className: "_User", objectId: id },
              ],
            },
          },
        }));

        const isAdmin = await checkAdmin();

        if (isAdmin) {
          await httpService.post("/parse/batch", {
            requests: previousRoles.length ? clearRequests : [],
          });
          await httpService.post("/parse/batch", {
            requests: roles.length ? updateRequests : [],
          });
          await httpService.put(`/parse/users/${id}`, account, {
            headers: {
              "X-Parse-Master-Key": "LASDK106JKHR87SDFJSDHF0DFHASFDF",
            },
          });
          toastrCRUDSuccess("Account", TEXT_PUT);
        } else {
          toastrErrorAlert("You cannot edit account!");
        }
        return;
      }
      const userUrl = "/parse/classes/_User";
      const { objectId: objId } = await httpService.post(userUrl, account);

      if (roles) {
        const requests = roles.map(role => {
          return {
            method: "PUT",
            path: `/parse/classes/_Role/${role.objectId}`,
            body: {
              users: {
                __op: "AddRelation",
                objects: [
                  { __type: "Pointer", className: "_User", objectId: objId },
                ],
              },
            },
          };
        });
        await httpService.post("/parse/batch", { requests });
        toastrCRUDSuccess("Account", TEXT_POST);
        history.replace(`/account/${objId}`);
        return;
      }

      toastrCRUDSuccess("Account", TEXT_POST);
      history.replace(`/account/${objId}`);
    } catch (errorRes) {
      if (errorRes.response?.data.code === 203) {
        toastrErrorAlert("Email đã được sử dụng!");
        return;
      }
      if (errorRes.response?.data.code === 202) {
        toastrErrorAlert("Tên đăng nhập đã được sử dụng!");
        return;
      }
      toastrErrorAlert(language_vn.error);
    }
  };

  const includeProps = {
    password: {
      hidden: Boolean(id),
    },
  };

  return (
    <div className="page-content">
      <Container fluid>
        <form onSubmit={handleSubmit(onSubmit)}>
          <HeaderCreateItem title="Thêm / Chi Tiết Tài Khoản">
            <CommonButton level={0}>Lưu</CommonButton>
          </HeaderCreateItem>
          {renderForm(excludeFields, includeProps)}
        </form>
      </Container>
    </div>
  );
};

export default NewAccount2;
